import './App.css'
import { Home } from './Home'

const App = () =>   <Home />

export default App
